import { createFileRoute } from '@tanstack/react-router'
import { PayrollSettings } from '@/features/organizations/settings/payroll'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/payroll'
)({
  component: PayrollSettings,
})
